import { useCallback, useEffect, useState, useMemo } from 'react';
import { GroupTagsContext, GroupTagsDispatchContext, GroupTagsUpdateContext, GroupTagsResetContext } from './Context';
import type { GroupSidebarTagsProps, GroupTagsContextValue } from './interfaces';

type Props
  = GroupSidebarTagsProps;

export const GroupTagsStateContainer = ({ tags, onSave, children }: Props & {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useState<GroupTagsContextValue>({
    editing: false,
    editable: true,
    tags: tags ?? [],
  });

  const handleReset = useCallback(() => {
    dispatch(state => ({ ...state, tags }));
  }, [tags]);

  useEffect(() => {
    dispatch(state => ({ ...state, tags }));
  }, [tags]);

  const canSave = useMemo(() => {
    return JSON.stringify(state.tags) !== JSON.stringify(tags);
  }, [state.tags, tags]);

  return (
    <GroupTagsContext.Provider value={state}>
      <GroupTagsResetContext.Provider value={handleReset}>
        <GroupTagsDispatchContext.Provider value={dispatch}>
          <GroupTagsUpdateContext.Provider value={[onSave, canSave]}>
            {children}
          </GroupTagsUpdateContext.Provider>
        </GroupTagsDispatchContext.Provider>
      </GroupTagsResetContext.Provider>
    </GroupTagsContext.Provider>
  );
};

// const initial: GroupTagsContextValue = {
//   editable: false,
//   editing: false,
//   tags: [],
// };

// function mergeInitial(initial: Partial<GroupTagsContextValue>) {
//   return {
//     ...GroupSidebarTags.initialState,
//     ...initial,
//   };
// }